import { InfoCircleOutlined } from '@ant-design/icons';
import React from 'react';
import CustomTooltip from '../../../UI/Tooltip/CustomTooltip';
import { RichTextEditor } from '../../../../pages/Task/components/editor/RichTextEditor';

interface AIDescriptionEditorProps {
  value: string;
  onChange: (value: string) => void;
  readOnly?: boolean;
  usersWithAccessToSpace?: Array<{
    id: number;
    fullName?: string | null;
    email: string;
    profilePicturePath?: string | null;
  }>;
  onAddSelectionToContext?: (selectedText: string) => void;
}

export const AIDescriptionEditor: React.FC<AIDescriptionEditorProps> = ({
  value,
  onChange,
  readOnly = false,
  usersWithAccessToSpace = [],
  onAddSelectionToContext,
}) => {
  return (
    <div className="py-4 pb-8">
      <div className="flex items-center justify-between gap-2 pb-2">
        <label className="text-xs font-semibold">Description</label>
        <CustomTooltip title="Your original description will remain unchanged for everyone, until you save the changes.">
          <div className="flex gap-1 text-xs font-normal bg-neutral-200 text-neutral-800 p-1 rounded cursor-default">
            Draft Mode
            <InfoCircleOutlined />
          </div>
        </CustomTooltip>
      </div>
      <RichTextEditor
        value={value}
        onChange={onChange}
        readOnly={readOnly}
        usersWithAccessToSpace={usersWithAccessToSpace}
        placeholder="What is this task about?"
        minHeight="300px"
        onAddSelectionToContext={onAddSelectionToContext}
      />
    </div>
  );
};
